<script>
    export let content;

    import Button from '../common/Button.svelte'
    import WYSIWYGText from '../common/WYSIWYGText.svelte'

    import { getURL } from '../../utils/functions'

    const title = content.title;
    const text = content.text;
    const button = content.button;
    const anchor = content.anchor;
    const media = content.media;

    const textBlocks = JSON.parse(text).blocks
</script>

<!-- Begin of about us section -->
<div class="section section-about section-cent fp-auto-height-responsive bg-primary" data-section={anchor}>
		
    <section class="content clearfix">
        <!-- Begin of Content -->
        <div class="content-centered c-columns fit">

            <div class="wrapper fullsize anim">
                <div class="desc-img desc-left">
                    <div class="w-text">
                        <!-- title and description -->
                        <div class="title-desc">
                            <span class="anim-wrapper">
                                <h2 class="border">{title}</h2>
                            </span>
                            
                            <WYSIWYGText textBlocks={textBlocks} />
                        </div>

                        {#if button}
                            <Button link={button.Link}>{button.Text}</Button>
                        {/if}
                    </div>
                    <div class="w-img">
                        <div class="img bg-img" data-image-src={getURL(media.url)}></div>
                    </div>
                </div>


            </div>
        </div>
        <!-- End of Content -->
    </section>
</div>
<!-- End of about us section -->

<style>
    
</style>